import Flickity from 'flickity';
import 'flickity-imagesloaded';

const initCarousel = (el, selectors) => {
  const carousel = el.querySelector(selectors.mainCarousel);

  if (carousel) {
    const carouselOptions = {
      cellAlign: 'left',
      freeScroll: false,
      prevNextButtons: false,
      pageDots: false,
      contain: true,
      imagesLoaded: true,
      initialIndex: 0,
    };

    const slider = new Flickity(carousel, carouselOptions);
    const prevBtn = el.querySelector(selectors.prevBtn);
    const nextBtn = el.querySelector(selectors.nextBtn);

    prevBtn.addEventListener('click', () => {
      slider.previous();
    });

    nextBtn.addEventListener('click', () => {
      slider.next();
    });

    // Disable next button if the last slide is already on the screen (prevents over scrolling index)
    slider.on('change', index => {
      if (index === 0) {
        prevBtn.setAttribute('disabled', 'true');
      } else {
        prevBtn.removeAttribute('disabled', 'true');
      }

      // figure out the last/first slides
      const floor = ~~(
        slider.size.width /
        slider.cells[0].element.offsetWidth /
        2
      );

      const ceil = slider.cells.length - floor;

      if (index + floor >= ceil) {
        slider.select(ceil - floor);
        nextBtn.setAttribute('disabled', 'true');
      } else if (index < ceil) {
        nextBtn.removeAttribute('disabled', 'false');
        slider.select(index);
      }
    });
  }
};

export default initCarousel;
